import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './AddSupplierUserModal.module.scss';
import Input from '../../blocks/Input';
import MultipleSelect from '../../common/MultipleSelect';
import SimpleCheckbox from '../../common/SimpleCheckbox';
import { requiredValidator, emailValidator } from '../../../utils/validators';
import { useDispatch, useSelector } from 'react-redux';
import { alertError } from '../../../store/actions/alert';

function AddSupplierUserModal(props) {
  const { onClose, opened = false, allRetailers = [] } = props;
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [isAdmin, setIsAdmin] = useState(true);
  const [retailerIds, setRetailerIds] = useState([]);

  const resetForm = () => {
    setEmail('');
    setIsAdmin(true);
    setRetailerIds([]);
  };
  const { users, isLoading } = useSelector((state) => state.supplierAdminUsers ?? {});

  const emails = useMemo(() => users?.map((user) => user.email), [users]);
  const buttonIsDisabled = () => {
    return isLoading || !email || (!isAdmin && retailerIds.length === 0);
  };

  const handleSubmit = (event) => {
    if (emails?.includes(email)) {
      dispatch(alertError(new Error(`User with email ${email} already exists.`)));
      event.preventDefault();
      return;
    }
    const data = {
      email: email,
      is_admin: isAdmin,
    };

    if (!isAdmin) {
      data.retailer_ids = retailerIds;
    }

    props.addSupplierUser(data);

    event.preventDefault();
    props.onClose();
    resetForm();
  };

  return (
    <ModalWindow open={opened} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <h2>Add Supplier User</h2>

        <hr />

        <div className={styles.body}>
          <label className={styles.emailField}>
            <div>Email address</div>
            <Input
              name="email"
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              value={email}
              validate={[requiredValidator, emailValidator]}
              blur
            />
          </label>

          <SimpleCheckbox value={1} label="Is Admin?" checked={isAdmin} onChange={setIsAdmin} />

          {isAdmin ? null : (
            <div className={styles.retailers}>
              <MultipleSelect options={allRetailers} selected={retailerIds} onChange={setRetailerIds} sort />
            </div>
          )}
        </div>

        <hr />

        <div className={styles.footer}>
          <Button type="submit" text="SAVE" disabled={buttonIsDisabled()} />
          <Button color="white" text="CANCEL" onClick={onClose} />
        </div>
      </form>
    </ModalWindow>
  );
}

export default AddSupplierUserModal;

AddSupplierUserModal.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  allRetailers: PropTypes.array,
  addSupplierUser: PropTypes.func.isRequired,
};
